/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { ContextualHelp, Typography2 } from '@coursera/cds-core';

import Modal from 'bundles/unified-description-page-common/components/shared/modals/Modal';
import type { ModalProps } from 'bundles/unified-description-page-common/components/shared/modals/Modal';

import _t from 'i18n!nls/xdp';

type Props = Omit<ModalProps, 'open' | 'setOpen'> & {
  title?: React.ReactNode | null;
  subtitle?: React.ReactNode;
  modalTitle?: React.ReactNode;
};

const KeyInformationDetailsItemModal = ({ title, subtitle, modalTitle, ...rest }: Props) => {
  return (
    <ContextualHelp
      helpToggleProps={{
        'aria-label': _t('More information about this item'),
      }}
      label={
        <Typography2 variant="subtitleLarge" component="div">
          {title}
        </Typography2>
      }
    >
      {({ onClose, isExpanded = false }) => (
        <Modal {...rest} setOpen={onClose} open={!!isExpanded} header={modalTitle ?? title}>
          <Typography2 variant="bodyPrimary" component="div">
            {subtitle}
          </Typography2>
        </Modal>
      )}
    </ContextualHelp>
  );
};

export default KeyInformationDetailsItemModal;
